var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCellphoneLives(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.111,
    height: 123.675,
    viewBox: "0 0 68.111 123.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.1,
    y1: 0.555,
    x2: 1.152,
    y2: 0.54,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b7ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cellphoneLives",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_214",
    "data-name": "Grupo 214",
    transform: "translate(-0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_555",
    "data-name": "Caminho 555",
    d: "M63.989,52.267v1.57Q64,84.2,64,114.57a8.84,8.84,0,0,1-7.067,8.971,6.968,6.968,0,0,1-1.556.13q-23.3.007-46.605,0A8.672,8.672,0,0,1,.02,114.942Q-.009,61.812,0,8.688A8.679,8.679,0,0,1,8.771,0Q31.832,0,54.893.012a8.749,8.749,0,0,1,9.06,9.058c.027,8.41.017,16.823.022,25.234v1.471c.459.063.809.118,1.162.162A3.022,3.022,0,0,1,68.1,39.212c.012,3.1.007,6.2,0,9.3,0,2.5-1.017,3.553-3.546,3.679-.152.007-.3.041-.572.08Zm-2.353,58.648v-1.266q.047-47.81.116-95.621c0-1.1-.292-1.42-1.411-1.418q-28.372.083-56.745.1c-.425,0-.848.053-1.319.087v98.123H61.637ZM61.586,10.374c.739-4.657-2.217-8.186-6.787-8.191Q37,2.165,19.2,2.191c-3.418,0-6.838-.039-10.256.012a6.606,6.606,0,0,0-6.514,8.171H61.586Zm-.085,103H2.261c-.343,4.824,2.372,8.094,6.753,8.1q22.927.036,45.854-.007c4.5-.01,7.372-3.548,6.633-8.092Zm2.543-75.145V49.847c1.527.2,1.828-.039,1.836-1.415q.018-4.348.007-8.693c0-1.454-.2-1.613-1.841-1.512Z",
    transform: "translate(0.002)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_556",
    "data-name": "Caminho 556",
    d: "M67.644,141.945H86.352c1.659,0,1.906.242,1.908,1.865q.018,16.235.027,32.468c0,1.478-.37,1.862-1.843,1.862q-18.829-.011-37.658-.041c-1.454,0-1.773-.333-1.773-1.773Q47,159.971,47,143.616c0-1.447.229-1.676,1.693-1.679q9.474-.011,18.949,0v.012Zm18.3,33.818V144.2H49.275v31.564H85.939Z",
    transform: "translate(-35.647 -107.651)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_557",
    "data-name": "Caminho 557",
    d: "M72.453,342.876c-4.628,0-9.256.01-13.884-.012a1.38,1.38,0,0,0-1.406.792,3.76,3.76,0,0,1-6.563.058,1.51,1.51,0,0,0-1.618-.862,3.665,3.665,0,0,1-1.553-.056c-.413-.164-.935-.642-.961-1.017-.024-.345.57-1.075.841-1.051,1.877.164,3.036-.727,4.314-2.027,1.582-1.609,4.316-.973,5.488,1.034a1.577,1.577,0,0,0,1.626.858q13.521-.047,27.045-.046c.944,0,2.22-.2,2.254,1.15.034,1.372-1.222,1.2-2.181,1.2H72.45v-.024Zm-20.243-1.258a1.724,1.724,0,0,0,1.587,1.773,1.756,1.756,0,0,0,1.71-1.539,1.654,1.654,0,0,0-3.3-.237Z",
    transform: "translate(-35.243 -256.202)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_558",
    "data-name": "Caminho 558",
    d: "M103.222,481.01q3.8,0,7.606,0c.812,0,1.628.068,1.657,1.113.031,1.128-.831,1.23-1.681,1.23q-7.667,0-15.333-.012c-.814,0-1.616-.123-1.6-1.181s.8-1.147,1.626-1.145c2.575,0,5.152,0,7.727,0Z",
    transform: "translate(-71.195 -364.827)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_559",
    "data-name": "Caminho 559",
    d: "M93.444,183.284c0-2.932-.014-5.867,0-8.8.012-1.766.734-2.169,2.27-1.285q7.721,4.446,15.427,8.918c1.461.848,1.449,1.664-.041,2.527q-7.71,4.467-15.434,8.908c-1.529.879-2.2.473-2.205-1.348-.017-2.973,0-5.947,0-8.92h-.019Zm15.463.082-13.123-7.572v15.154l13.123-7.584Z",
    transform: "translate(-70.869 -131.022)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphoneLives);
export default __webpack_public_path__ + "static/media/cellphoneLives.4cc90ae77196320771ccf5ac5e4b4779.svg";
export { ForwardRef as ReactComponent };